import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _ProductLot, _RawMaterialByProductionOrder } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicMultiSelectTable } from '../../../../../../theme/Component/BasicMultiSelecTable';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import { ListMenu } from '../../../../../../theme/Component/ListMenu';
import { _single } from '../../../../../../../core/services/dataBean/EntityCatalog';
import { Modal } from '../../../../../../theme/Component/Modal';
import { InputDate } from '../../../../../../theme/Input/InputDate';
import { ProductionOrderEditor } from '../../../../../../Factoty&Production/ProductionOrder/ProductionOrderEditor';



interface Props {
    idProductionOrder: any;
    productionOrderDate: any
    idSelector: number;
    onChange: any;
    label?: string;
}

export const InventoryOutCostFactorySelectfororder = ({ idSelector, onChange, label, idProductionOrder, productionOrderDate }: Props) => {
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [listaResult, setListaResult] = useState<any>([]);
    const lot = useDataBean(_ProductLot);
    // const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [idProductionOrder, productionOrderDate])

    useEffect(() => {
        onChange(lot.bean.IDLot);
    }, [lot.bean])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }
    const headMulti = [
        { title: 'ID', property: 'IDLot', visible: true },
        { title: 'Orden de Producción', property: 'ProductionOrderName', visible: true },
        { title: 'Código de Referencia de Lote', property: 'LotNumber', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Fecha de Empaque', property: 'ProductionDate', visible: true },
        { title: 'Vecha de Vencimiento', property: 'DueDate', visible: true },
        { title: 'Número de Cajas', property: 'BoxNumber', visible: true },
        { title: 'Items por Caja', property: 'ItemsPerBox', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
    ]

    const getLista = () => {
        lot.instance.getProductLotCatalogByProductionOrder(idProductionOrder, productionOrderDate).then(
            (resp) => {
                setLista(resp)
                console.log(resp)
            }
        )
    }

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Ver Impuesto', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setAddtable({ ...addtable, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const create = () => {
        lot.setBean({
            IDProductionOrder: idProductionOrder,
            ProductionOrderDate: productionOrderDate
        });
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]

    const editaritem = () => {
        lot.update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <>
            <Modal modal={modal} updateModal={setModal} eventModal={editaritem}>
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <ProductionOrderEditor IDOrderProduction={lot.bean.IDProductionOrder} returnData={(e) => { lot.setBean({ ...lot.bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Código de Referencia de Lote</label>
                            <input name="LotNumber" className="form-control" value={lot.bean.LotNumber} onChange={lot.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Fecha Empaque</label>
                            <InputDate name="desde" label="Hasta" value={lot.bean.ProductionDate} setDate={(e: any) => { lot.setBean({ ...lot.bean, "ProductionDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Fecha Vencimiento</label>
                            <InputDate name="desde" label="Hasta" value={lot.bean.DueDate} setDate={(e: any) => { lot.setBean({ ...lot.bean, "DueDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Número de Cajas</label>
                            <input name="BoxNumber" className="form-control" value={lot.bean.BoxNumber} onChange={lot.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Items por Caja</label>
                            <input name="ItemsPerBox" className="form-control" value={lot.bean.ItemsPerBox} onChange={lot.handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={lot.bean.Description} onChange={lot.handleChange} />
                        </div>
                    </div>
                </>
            </Modal>
            <p>Selecciona un Año para cargar Lote de Producción*</p>
            <label>{label ?? "Lote de Producción"}</label>

            {/* <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDRawMaterial} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select> */}
            {/* <BasicMultiSelectTable keyId="IDRawMaterial" body={lista} bodyResult={listaResult} head={headMulti}
                updateValues={({ bodyResult }) => {
                    setListaResult(bodyResult);
                    console.log(bodyResult)
                }}
            /> */}

            <BasicTable head={headMulti} body={lista} rowSet={lot.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
        </>
    )
}